export default __webpack_public_path__ + "static/15-5da0f30a03f6ff55d4d839120fb49d20.webp";